





































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";
import moment from 'moment';
import Add from "./price_extend_add.vue";
import Edit from "./price_extend_edit.vue";

@Component({
  components: {
    Add,
    Edit,
  },
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  @Prop() grounds!: [];

  dispatchType: string = "stadium/priceextend";

  deleteConfirmContent = "确定要删除该设置吗？";
  dispatchTypeDelete: string = "stadium/deletepriceextend";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "类型", scopedSlots: { customRender: "type" } },
    { title: "开始日期", scopedSlots: { customRender: "start_date" } },
    { title: "结束日期", scopedSlots: { customRender: "end_date" } },
    { title: "开始时段", scopedSlots: { customRender: "hour_from" } },
    { title: "结束时段", scopedSlots: { customRender: "hour_to" } },
    { title: "片场", scopedSlots: { customRender: "ground_id" } },
    { title: "价格", scopedSlots: { customRender: "price" } },
    { title: "更新时间", dataIndex: "updated_time" },
    { title: "操作", scopedSlots: { customRender: "action" } },
  ];

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId,
      },
      false
    );
  }
}
